import { __assign, __read, __rest } from "tslib";
import React, { useState, useEffect, useRef } from 'react';
import { AsYouType, isSupportedCountry, getCountryCallingCode, parseDigits } from 'libphonenumber-js/min';
import examplePhoneNumbers from 'libphonenumber-js/examples.mobile.json';
import { getNextCursorPosition } from '../utils';
import { Input } from './Input';
import { createEasyInput } from './EasyInput';
export var getRawMaxLength = function (countryCode, value) {
    var countryCallingCode = getCountryCallingCode(countryCode);
    var beginsWithCountryCode = parseDigits(value).substr(0, countryCallingCode.length) === countryCallingCode;
    var examplePhoneNumber = examplePhoneNumbers[countryCode];
    return beginsWithCountryCode ? countryCallingCode.length + examplePhoneNumber.length : examplePhoneNumber.length;
};
export var PhoneInput = function (_a) {
    var countryCode = _a.countryCode, forwardedRef = _a.forwardedRef, propValue = _a.value, onKeyDown = _a.onKeyDown, onChange = _a.onChange, inputProps = __rest(_a, ["countryCode", "forwardedRef", "value", "onKeyDown", "onChange"]);
    var countryCodeSupported = countryCode && isSupportedCountry(countryCode);
    if (!countryCodeSupported) {
        throw new Error(countryCode + " is not supported");
    }
    var format = function (value) {
        var phoneString = value || '';
        var parsed = parseDigits(phoneString).substr(0, getRawMaxLength(countryCode, phoneString));
        return new AsYouType(countryCode).input(parsed);
    };
    var _b = __read(useState(format(propValue)), 2), currentValue = _b[0], setValue = _b[1];
    var ref = useRef();
    var inputRef = forwardedRef || ref;
    useEffect(function () {
        if (propValue !== currentValue) {
            setValue(format(propValue));
        }
    }, [propValue]);
    var handleKeyDown = function (event) {
        var isLetterLike = /^\w{1}$/.test(event.key);
        if (isLetterLike) {
            var cursorPos = event.target.selectionStart;
            var nextFormattedValue = format(currentValue.substring(0, cursorPos) + event.key + currentValue.substring(cursorPos));
            var nextValueRawLength = parseDigits(currentValue).length + 1;
            if (nextValueRawLength > getRawMaxLength(countryCode, nextFormattedValue)) {
                event.preventDefault();
                event.stopPropagation();
            }
        }
        if (onKeyDown) {
            onKeyDown(event);
        }
    };
    var handleChange = function (name, newValue, event) {
        var nextValue = newValue.length < currentValue.length ? newValue.trim() : format(newValue);
        var nextCursorPosition = getNextCursorPosition(event.target.selectionStart, currentValue, nextValue);
        setValue(nextValue);
        setTimeout(function () {
            var _a;
            (_a = inputRef === null || inputRef === void 0 ? void 0 : inputRef.current) === null || _a === void 0 ? void 0 : _a.setSelectionRange(nextCursorPosition, nextCursorPosition);
        });
        if (onChange) {
            onChange(name, nextValue, event);
        }
    };
    return (React.createElement(Input, __assign({ type: "tel", forwardedRef: inputRef, value: currentValue, onKeyDown: handleKeyDown, onChange: handleChange }, inputProps)));
};
PhoneInput.defaultProps = {
    countryCode: 'US',
};
export default createEasyInput(PhoneInput);
//# sourceMappingURL=PhoneInput.js.map